import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/modal/Modal';
import { Button } from '@ui';
import styles from './AskFeedbackPrompt.module.css';

export default function AskFeedbackPrompt({ modalOpen, setModalOpen, onLeaveFeedback, onDontAskAgain }) {
  const { t } = useTranslation();

  return (
    <Modal modalOpen={modalOpen} setModalOpen={setModalOpen}>
      <div className={styles.root}>
        <h2 className={styles.title}>{t('feedback.askPromptTitle')}</h2>
        <p className={styles.body}>{t('feedback.askPromptBody')}</p>
        <Button
          type="button"
          className={styles.primary}
          onClick={() => {
            setModalOpen(false);
            onLeaveFeedback?.();
          }}
        >
          <span>{t('feedback.askPromptLeave')}</span>
        </Button>
        <Button type="button" variant="outline" className={styles.secondary} onClick={() => setModalOpen(false)}>
          <span>{t('feedback.askPromptClose')}</span>
        </Button>
        <button
          type="button"
          className={styles.dontAsk}
          onClick={() => {
            onDontAskAgain?.();
            setModalOpen(false);
          }}
        >
          {t('feedback.askPromptDontAsk')}
        </button>
      </div>
    </Modal>
  );
}
